import { Component } from "react";
import PropTypes from "prop-types";

export default class SharedRef extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
  };

  setInnerRef = node => {
    this.currentRef = node;
  };

  render = () =>
    this.props.children({
      current: () => this.currentRef,
      innerRef: this.setInnerRef,
    });
}
